import { Moment } from 'moment-timezone';

import { TypeKeys, WidgetBlockAction } from './types';

type ReportTimeAction = WidgetBlockAction<TypeKeys.SET_REPORT_TIME, { reportTime: Moment }>;

/**
 * @deprecated since version 4.2.0.
 * Use action setTime instead
 *
 * @param {*} widgetId
 * @param {*} instanceId
 * @param {*} site
 */
const setReportTime = (widgetId: string, instanceId: string, reportTime: Moment): ReportTimeAction => ({
    type: TypeKeys.SET_REPORT_TIME,
    payload: {
        widgetId,
        instanceId,
        reportTime,
    },
});

export default setReportTime;
export { ReportTimeAction };
